export const BID_MAP = {
    MODULE_MV: 'b_daodian_lowcode_f248eftt_mv',
    // 模块曝光
    CITY_MV: 'b_daodian_lowcode_eux1pxx7_mv',
    // 城市曝光
    CITY_MC: 'b_daodian_lowcode_z24bqdy4_mc',
    //城市点击
    RECOMMEND_MV: 'b_daodian_lowcode_yy43gupy_mv',
    // 攻略模块曝光
    VIEW_MORE_MC: 'b_daodian_lowcode_fgoyfjtr_mc',
    // 查看更多跳转
    ITEM_MV: 'b_daodian_lowcode_98zwo3mb_mv',
    // 攻略单元曝光
    ITEM_MC: 'b_daodian_lowcode_r571rg9y_mc' // 攻略单元切换
};
export var BID_TYPE;
(function (BID_TYPE) {
    BID_TYPE["MV"] = "mv";
    BID_TYPE["MC"] = "mc";
    BID_TYPE["MC_WITH_TAG"] = "mc_with_tag";
})(BID_TYPE || (BID_TYPE = {}));
